import { PrimaryControlsStripExpansion } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.expansion";
import {
  BrowseLearnedProgress,
  useBrowseDatasetStatsQueryOptions,
} from "@-/dev.improve.haniverse.routes.nav.app.browse._components.dataset-stats";
import { BrowsePrimaryControlsStripExpansionPushButtons } from "@-/dev.improve.haniverse.routes.nav.app.browse._components.primary-controls-strip-expansion-push-buttons";
import { useStudiedGraphemesQueryOptions } from "@-/dev.improve.haniverse.lib.cards.user-card.grapheme.meaning.read";
import { useQuery } from "@-/com.npmjs.tanstack__react-query";
import { useMemo } from "react";
import arrayLength from "@-/com.npmjs.extra-array__length";

/**
 * Header expansion strip for the Browse Characters page: how many of the HSK-dataset
 * characters the user has learned. A character counts as learned when its glyph is in the
 * user's studied-grapheme set.
 */
export function BrowseCharactersPrimaryControlsStripExpansionContent() {
  const { data: stats } = useQuery(useBrowseDatasetStatsQueryOptions());
  const { data: studiedGraphemes } = useQuery(useStudiedGraphemesQueryOptions());

  const { learnedCount, totalCount } = useMemo(() => {
    const characters = stats?.characters ?? [];
    const studied = studiedGraphemes ?? new Set<string>();
    let learned = 0;
    for (const character of characters) {
      if (studied.has(character)) {
        learned++;
      }
    }
    return { learnedCount: learned, totalCount: arrayLength(characters) };
  }, [studiedGraphemes, stats]);

  return (
    <PrimaryControlsStripExpansion>
      <BrowseLearnedProgress learnedCount={learnedCount} noun="character" totalCount={totalCount} />
      <BrowsePrimaryControlsStripExpansionPushButtons />
    </PrimaryControlsStripExpansion>
  );
}
